import EllipsisThinIcon from '@assets/icons/ellipsis-thin.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

const MORE_ACTIONS_HIT_SLOP = { bottom: 20, left: 20, right: 20, top: 20 };

interface Props {
  onPressMore: () => void;
  style?: StyleProp<ViewStyle>;
}

export const TouchableEllipsis = React.forwardRef<
  React.ComponentRef<typeof TouchableOpacity>,
  Props
>(({ onPressMore, style }, ref) => {
  const theme = useTheme();
  return (
    <TouchableOpacity
      accessibilityLabel={i18n.t('more_actions')}
      hitSlop={MORE_ACTIONS_HIT_SLOP}
      onPress={onPressMore}
      ref={ref}
      style={style}
    >
      <EllipsisThinIcon
        fill={theme.sk.color.icon.tertiary}
        stroke={theme.sk.color.icon.tertiary}
      />
    </TouchableOpacity>
  );
});
